// GR-3396: does this query name this state?
//
// SelectPanel's stock filter is a substring test over the rendered label, which
// gets "FL - Florida" from "flo" but also offers Indiana, Illinois, Virginia
// and Washington for "in", because the letters appear somewhere inside each.
// Richard asked for the box to match "name and code FL Tex TX etc", which is a
// narrower question: the query is the start of the code, or the start of a word
// in the name.
//
// Word-start rather than anywhere is what keeps the list short enough to be
// worth reading, and it still finds "new y" for New York and "columbia" for
// District of Columbia, because every word counts as a start.

const normalize = (value) => value.toString().trim().toLowerCase();

export function matchesRegion(region, query) {
  const needle = normalize(query ?? "");
  if (needle === "") return true;

  const code = normalize(region.code ?? "");
  if (code.startsWith(needle)) return true;

  const name = normalize(region.name ?? "");
  if (name === "") return false;

  // The whole name from its start, or any word within it: "york" and "new y"
  // both name New York, "ida" names nothing.
  return name.split(/\s+/).some((word, index) => {
    if (word.startsWith(needle)) return true;
    // A query spanning a space can only start at the first word.
    return index === 0 && name.startsWith(needle);
  });
}

// The callback SelectPanel wants: (item, query) => boolean. The row carries its
// own code and name, so the matcher never has to unpick a rendered label.
export function regionFilterFn(item, query) {
  const content = item.querySelector("[data-region-code]") || item;
  return matchesRegion(
    { code: content.dataset.regionCode, name: content.dataset.regionName },
    query
  );
}
